<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoDetalhar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoDetalhar">
			
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="loading">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="w-auto mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid pt-3 px-3" *ngIf="adicionalEDesconto">
						<div class="col-12 card-simple mb-3">
							<div class="p-fluid p-formgrid grid">
								<div class="col-12 md:col-3">
									<label class="label-superior">Profissional</label>
									<label class="label-inferior">{{ exibirNomeProfissional(adicionalEDesconto.profissionalId) }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Descrição</label>
									<label class="label-inferior">{{ adicionalEDesconto.descricao }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Data Registro</label>
									<label class="label-inferior">{{ adicionalEDesconto.dataRegistro | date:'dd/MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Competência</label>
									<label class="label-inferior">{{ adicionalEDesconto.dataCompetencia | date:'MM/yyyy' }}</label>
								</div>
								<div class="col-12 md:col-2">
									<label class="label-superior">Valor</label>
									<label class="label-inferior">{{ adicionalEDesconto.valorRegistro | currency:'BRL' }}</label>
								</div>
							</div>
						</div>
						
					</div>
					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!loading">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button"  pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/adicionais-e-descontos"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>